module.exports = __webpack_public_path__ + "static/media/ScrollBarDown.2606f632.svg";